import { render, staticRenderFns } from "./Myexchange.vue?vue&type=template&id=c13b2138&scoped=true"
import script from "./Myexchange.vue?vue&type=script&lang=js"
export * from "./Myexchange.vue?vue&type=script&lang=js"
import style0 from "./Myexchange.vue?vue&type=style&index=0&id=c13b2138&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13b2138",
  null
  
)

export default component.exports